document.addEventListener("DOMContentLoaded", function () {
  const verticalSliders = document.querySelectorAll(".vertical-slider");

  verticalSliders.forEach(function (slider) {
    const sliderSection = slider.closest(".vertical-slider-section");

    new Swiper(slider, {
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 10,
        
        // This is the key setting to scroll multiple slides at once
        slidesPerGroup: 3,  // Will jump 3 slides at a time
        
        loop: false,
        
        // Enhanced end behavior
        allowSlideNext: true,
        allowSlidePrev: true,
        rewind: false,
        
        // Adjust mousewheel to respect the slidesPerGroup setting
        mousewheel: {
            invert: false,
            sensitivity: 0.85,
            eventsTarget: '.vertical-slider',
            releaseOnEdges: true,
            forceToAxis: true
        },
        
        // Rest of your configuration...
        
        autoHeight: true,
        
        // You may want to disable this for group scrolling
        slideToClickedSlide: false,
        
        // Navigation should also respect the group size
        navigation: {
            nextEl: sliderSection.querySelector('.swiper-button-next-unique'),
            prevEl: sliderSection.querySelector('.swiper-button-prev-unique'),
        },
        
        speed: 800,
        effect: 'slide',
        
        nested: true,
    });
  });
});
